export const SAML_SERVICE_PROVIDER_CONSUME_URL = process.env.REACT_APP_SAML_SERVICE_PROVIDER_CONSUME_URL;



// WEBPACK FOOTER //
// ./src/data/saml.js